/** Commit of the build, stamped by the deploy: `ng build --define I18N_VERSION="'<commit>'"`. */
declare const I18N_VERSION: string | undefined;

/**
 * Suffix of the translation file URLs. The files sit at fixed URLs under `/assets/i18n/`,
 * outside the hashed bundles, so after a deploy a browser could pair a new bundle with a
 * cached old file and print raw keys. The deploy puts its commit in the query string, so
 * each deploy asks for a new URL; a build without it (local `ng serve`, tests) uses `local`.
 */
export function i18nFileSuffix(version: string | undefined = readI18nVersion()): string {
  return `.json?v=${encodeURIComponent(version?.trim() || 'local')}`;
}

function readI18nVersion(): string | undefined {
  return typeof I18N_VERSION === 'string' ? I18N_VERSION : undefined;
}
